/* Enalika — scroll experience. No dependencies, transform/opacity only.

   Two gotchas encoded here:
   1. This theme scrolls an inner element (.page-wrapper), not the window, so window
      'scroll' never fires. Scroll does not bubble, but capture-phase listeners on
      document DO receive it from any scroller — that is what onScroll uses.
   2. The hero image runs a continuous CSS push-in animation, so parallax must move the
      WRAPPER (.en-hero__media). Writing an inline transform on the <img> would kill it. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onScroll(fn) {
    var ticking = false;
    function handler() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { fn(); ticking = false; });
    }
    document.addEventListener('scroll', handler, { passive: true, capture: true });
    window.addEventListener('resize', handler, { passive: true });
    fn();
  }

  function scroller() {
    var w = document.querySelector('.page-wrapper');
    if (w && w.scrollHeight - w.clientHeight > 40) return w;
    return document.scrollingElement || document.documentElement;
  }

  function curtain() {
    if (reduced) return;
    try { if (sessionStorage.getItem('en_seen')) return; } catch (e) { return; }
    var el = document.createElement('div');
    el.className = 'en-curtain';
    el.innerHTML = '<span>ENALIKA</span>';
    document.body.appendChild(el);
    try { sessionStorage.setItem('en_seen', '1'); } catch (e) {}
    setTimeout(function () {
      el.setAttribute('hidden-soft', '');
      setTimeout(function () { el.remove(); }, 950);
    }, 1400);
  }

  function progress() {
    var bar = document.createElement('div');
    bar.className = 'en-progress';
    document.body.appendChild(bar);
    onScroll(function () {
      var el = scroller();
      var max = el.scrollHeight - el.clientHeight;
      var y = (el === document.scrollingElement || el === document.documentElement)
        ? (window.scrollY || el.scrollTop) : el.scrollTop;
      bar.style.width = (max > 0 ? Math.min(100, (y / max) * 100) : 0) + '%';
    });
  }

  function reveals() {
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('en-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    var targets = [];

    function skip(el) {
      return el.tagName === 'IMG' || el.tagName === 'PICTURE' ||
             el.closest('.en-hero__media') || el.closest('#header-group') ||
             el.closest('.en-statement');
    }

    document.querySelectorAll('#MainContent .shopify-section').forEach(function (sec) {
      var picked = 0;
      sec.querySelectorAll(':scope > * > *, :scope > * > * > *').forEach(function (k) {
        if (picked >= 6) return;
        if (k.classList.contains('en-reveal') || skip(k)) return;
        var r = k.getBoundingClientRect();
        if (r.height < 18 || r.height > window.innerHeight * 2.2) return;
        k.classList.add('en-reveal');
        if (picked === 1) k.classList.add('en-d1');
        else if (picked === 2) k.classList.add('en-d2');
        else if (picked >= 3) k.classList.add('en-d3');
        targets.push(k);
        picked++;
      });
    });

    document.querySelectorAll('.resource-list__item').forEach(function (it, i) {
      it.classList.add('en-reveal', 'en-d' + ((i % 4) + 1));
      targets.push(it);
    });

    document.querySelectorAll('.en-reveal').forEach(function (t) {
      if (targets.indexOf(t) === -1) targets.push(t);
    });

    targets.forEach(function (t) { io.observe(t); });
  }

  /* parallax moves the wrapper; the <img> keeps its CSS push-in animation */
  function parallax() {
    if (reduced) return;
    var hero = document.querySelector('.en-hero');
    var media = document.querySelector('.en-hero__media');
    var img = document.querySelector('.en-hero__media img');
    if (!hero || !media) return;
    if (img) img.classList.remove('en-reveal', 'en-in');
    media.classList.remove('en-reveal', 'en-in');
    onScroll(function () {
      var top = hero.getBoundingClientRect().top;
      media.style.transform = 'translate3d(0,' + (-top * 0.13).toFixed(2) + 'px,0)';
    });
  }

  function statement() {
    var p = document.querySelector('.en-statement p');
    if (!p || p.dataset.split) return;
    p.dataset.split = '1';
    var words = p.textContent.trim().split(/\s+/);
    p.textContent = '';
    words.forEach(function (w, i) {
      var s = document.createElement('span');
      s.className = 'en-word';
      s.textContent = w;
      p.appendChild(s);
      if (i < words.length - 1) p.appendChild(document.createTextNode(' '));
    });
    var spans = p.querySelectorAll('.en-word');
    if (reduced) { spans.forEach(function (w) { w.classList.add('on'); }); return; }
    onScroll(function () {
      var r = p.getBoundingClientRect();
      var start = window.innerHeight * 0.92;
      var end = window.innerHeight * 0.34;
      var prog = (start - r.top) / (start - end);
      prog = Math.max(0, Math.min(1, prog));
      var lit = Math.round(prog * spans.length);
      for (var i = 0; i < spans.length; i++) spans[i].classList.toggle('on', i < lit);
    });
  }

  function boot() { curtain(); progress(); reveals(); parallax(); statement(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
